module.exports = __webpack_public_path__ + "img/problems-2.67ce5409.png";